'use strict';

angular.module('accessRequestModule')
    .controller('AccessRequestCtrl', function ($scope, $http)
    {
        this.errors = null;

        this.messages = {
            error: null,
            success: null
        };

        this.showForm = true;
        this.eye = 'toggle-visible';

        const init = function () {
            $scope.contactInfo = {
                name: '',
                email: '',
                password: '',
                company: '',
                rationale: '',
            }
        }

        this.changeIconClass = function() {
            this.eye = this.eye === 'toggle-hide' ? 'toggle-visible' : 'toggle-hide';
        }

        this.sendRequest = function () {

            this.showForm = true;
            this.errors = null;

            $http.post('/api/access-request', $scope.contactInfo).then(this.onGoodResponse.bind(this))
                .catch(this.onBadResponse.bind(this));
        }

        this.onGoodResponse = function(response) {
            this.showForm = false;
            this.messages.success = response.data.message;
            this.messages.error = null;
        }

        this.onBadResponse = function (response) {

            if (response.status === 401) {
                this.messages.error = response.data.message;
                this.messages.success = null;
            }

            if (response.data.errors) {
                this.errors = response.data.errors;
            }
        }

        init();
    });
